import { Reveal, Overline } from "./Reveal";

export default function Services({ services }) {
  return (
    <section id="servicios" className="relative py-28 sm:py-36 bg-jauja-olive/10" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal><Overline>{services.overline}</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display font-medium tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl">
              {services.title}
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 text-lg leading-relaxed text-white/70">{services.intro}</p>
          </Reveal>
        </div>

        <div className="mt-16 border-t border-white/10">
          {(services.items || []).map((item, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="group grid md:grid-cols-12 gap-4 md:gap-8 items-baseline border-b border-white/10 py-8 md:py-10 transition-colors duration-300 hover:bg-white/[0.02]">
                <div className="md:col-span-2 font-display text-5xl md:text-6xl text-jauja-olive group-hover:text-jauja-lime transition-colors duration-300">
                  {item.number}
                </div>
                <h3 className="md:col-span-3 font-display text-2xl md:text-3xl text-white">{item.title}</h3>
                <p className="md:col-span-7 text-base sm:text-lg leading-relaxed text-white/60">{item.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
